import { useState, useContext } from 'react';
import { Card } from 'primereact/card';
import { classNames } from 'primereact/utils';
import ReactMarkdown from 'react-markdown';
import 'primeflex/primeflex.css';
import { toast } from 'react-toastify';
import './CharlyChatMessage.scss';
import { MainContext } from '../../App';
import usePatchUserFeedbackType from '../../hooks/usePatchUserFeedbackType'
import remarkGfm from 'remark-gfm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown } from '@fortawesome/free-regular-svg-icons';

function LinkRenderer(props) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}

const mdComponents = {
  a: LinkRenderer,
  table: ({ node, ...props }) => (
    <table className="table table-light table-bordered w-auto" {...props} />
  )
};

function CharlyChatMessage({ type, text, feedback, chatMessageId }) {
  const isUser = type === 'UserInput';

  const { userId } = useContext(MainContext);

  const [feedbackGiven, setFeedbackGiven] = useState(feedback !== null && feedback !== undefined);
  const patchUserFeedbackType = usePatchUserFeedbackType();

  async function handleFeedback(){
    try {
        await patchUserFeedbackType(chatMessageId, userId);
    }
    catch(err) {
    toast.error("Er is iets misgegaan bij het verwerken van de feedback. Probeer het alstublieft opnieuw.")
    return;
    }
  }

  return (
    <div
      className={classNames('d-flex my-2', {
        'justify-content-end': isUser,
        'justify-content-start': !isUser,
      })}
    >
      <div className={classNames('message-wrapper', { 'text-end': isUser, 'text-start': !isUser })}>
        <Card
          className={classNames('chat-bubble no-padding-card', {
            'user-bubble': isUser,
            'agent-bubble': !isUser,
          })}
          style={{ borderRadius: '0.75rem' }}
        >
          <ReactMarkdown  components={mdComponents} remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
        </Card>
        {!isUser && chatMessageId !== 0 && (
            feedbackGiven
                ? <small className="text-muted mt-2 d-block">Bedankt voor je feedback</small>
                : <button 
                    className="btn btn-sm mt-2" 
                    onClick={() => {
                        setFeedbackGiven(true);
                        handleFeedback();
                    }}
                    >
                    <FontAwesomeIcon icon={faThumbsDown} /> Niet geholpen
                  </button>
        )}
      </div>
    </div>
  );
}

export default CharlyChatMessage;
